<template>
  <div
    class="loader"
    :class="color === 'white' ? 'loader-white' : 'loader-brand'"
    role="status"
    aria-live="polite"
    aria-label="Loading"
  >
    <span v-for="bar in 4" :key="bar" class="loader-bar"></span>
  </div>
</template>

<script>
export default {
  name: "loadingComponent",
  props: ["color"],
};
</script>

<style lang="scss" scoped>
.loader {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #6c30cc;
}

.loader-white {
  color: #ffffff;
}

.loader-brand {
  color: #6c30cc;
}

.loader-bar {
  width: 5px;
  height: 14px;
  border-radius: 999px;
  background: currentColor;
  opacity: 0.35;
  transform-origin: center bottom;
  animation: loader-wave 1.1s infinite ease-in-out;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08);
}

.loader-bar:nth-child(2) {
  animation-delay: 0.12s;
}

.loader-bar:nth-child(3) {
  animation-delay: 0.24s;
}

.loader-bar:nth-child(4) {
  animation-delay: 0.36s;
}

@keyframes loader-wave {
  0%,
  100% {
    transform: scaleY(0.55);
    opacity: 0.3;
  }

  40% {
    transform: scaleY(1.35);
    opacity: 1;
  }

  70% {
    transform: scaleY(0.8);
    opacity: 0.65;
  }
}

@media (prefers-reduced-motion: reduce) {
  .loader-bar {
    animation: none;
    opacity: 0.8;
    transform: scaleY(1);
  }
}
</style>
